<template>
  <section class="app-container">
    <!-- <van-dropdown-menu active-color="#1989fa">
      <van-dropdown-item v-model="params.pickerTime" @change="handleTimeChange" :options="params.pickerTimeOptions" />
    </van-dropdown-menu> -->
    <component :is="currentList" :orders="orders" :params="data">
    </component>
  </section>
</template>
<script>
import { Dialog, DropdownMenu, DropdownItem } from 'vant'
import Available from './components/Available'
import Unavailable from './components/Unavailable'
import { deepClone, getTimeval, parseTime } from '@/utils'
import { selectCarAndUserRel, getArrearsList } from '@/api/park'
import config from '@/config/index'
import { mapGetters } from 'vuex'
export default {
  name: 'Arrears-Bill-Temporary',
  computed: {
    ...mapGetters(['wx_userInfo', 'zfb_userInfo', 'wx_token', 'token', 'billParams', 'chosenTime'])
  },
  components: {
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Dialog.Component.name]: Dialog.Component,
    Available,
    Unavailable
  },
  data () {
    return {
      currentList: 'Unavailable',
      defultCarNumber: null,
      orders: [],
      config,
      params: {
        pickerTime: 30,
        pickerOrder: 0,
        largeCar: false,
        parkId: 0,
        outTradeNo: null,
        pickerTimeOptions: [
          { text: '最近半年', value: 180 }
        ],
        startDate: [
          parseTime(
            new Date(
              new Date(new Date().toLocaleDateString('zh').replace(/-/g, '/')).getTime() -
              24 * 60 * 60 * 1000 * 30
            )
          ),
          parseTime(new Date(
            new Date(new Date().toLocaleDateString('zh').replace(/-/g, '/')).getTime() +
            24 * 60 * 60 * 1000 - 1
          ))
        ],
      },
    }
  },
  watch: {
    chosenTime: {
      handler (newVal, oldVal) {
        this.params.pickerTimeOptions = newVal.pickerTimeOptions
        this.params.pickerTime = newVal.pickerTimeOptions[0].value
      },
      deep: true
    },

  },
  created () {
    this.handleFilter()
    this.params.pickerTimeOptions = this.chosenTime.pickerTimeOptions
    this.params.pickerTime = this.chosenTime.pickerTimeOptions[0].value
  },
  methods: {
    // 时间选项改变
    handleTimeChange (val) {
      this.params.startDate[0] = parseTime(new Date(new Date(new Date().toLocaleDateString('zh').replace(/-/g, '/')).getTime() - val * 24 * 60 * 60 * 1000))
      this.componentsValve()
    },
    //查询绑定车牌
    handleFilter () {
      let _this = this
      if (_this.$route.query.largeCar) {
        _this.params.largeCar = window.decodeURI(_this.$route.query.largeCar)
      }
      // 代人缴费
      if (_this.$route.query.cardNumber) {
        _this.defultCarNumber = window.decodeURI(_this.$route.query.cardNumber)
        _this.componentsValve()
        return
      }
      // 我要缴费
      let getInfo_Loading = _this.$toast.loading('加载中...')
      let params = {
        openid: _this.wx_userInfo ? _this.wx_userInfo.openid : _this.zfb_userInfo.userId
      }
      selectCarAndUserRel(params)
        .then(response => {
          let data = response.body
          getInfo_Loading.clear()
          _this.defultCarNumber = null
          for (let index = 0; index < data.length; index++) {
            const element = data[index]
            if (element.isDefaultCar) {
              _this.defultCarNumber = element.cardNumber
            }
          }
          if (!_this.defultCarNumber) {
            _this.$store.dispatch('app/setBackflow', _this.$options.name)
            _this.$router.push({ name: 'My-Car' })
          } else {
            _this.componentsValve()
          }
        })
        .catch(error => {
          getInfo_Loading.clear()
          _this.$notify({
            type: 'danger',
            message: error
          })
        })
    },
    // 查询数据
    componentsValve () {
      let _this = this
      let getInfo_Loading = _this.$toast.loading('加载中...')
      let params = {
        cardNumber: _this.defultCarNumber,
        parkId: _this.params.parkId,//0所有停车场
        largeCar: _this.params.largeCar,
        startPage: 1,
        pageSize: 10,
        startTime: _this.params.startDate[0],
        endTime: _this.params.startDate[1],
      }
      this.data = params
      getArrearsList(params).then(response => {
        let data = response.body

        data.data.forEach(element => {
          if (typeof element.unPaidMoney === 'number') {
            element.priceArr = element.unPaidMoney.toFixed(2).split('.')
          }
          if (element.entranceDate) {
            let exitDate = element.exitDate || parseTime(new Date())
            element.parkingTime = getTimeval(element.entranceDate, exitDate)
            if (element.parkingTime == '0天0时0分' && _this.config.projectName == 'JNJT') {
              element.parkingTime = '不足1小时'
            }
          }
        });
        _this.orders = deepClone(data.data)
        getInfo_Loading.clear()
        if (data.data.length > 0) {
          _this.currentList = "Available"
        } else {
          _this.currentList = "Unavailable"
        }
      })
        .catch(error => {
          _this.$notify({
            type: 'danger',
            message: error
          })
        })
    },
  }
}
</script>